import ThisModule from "./PageTermsOfUse";

export default ThisModule;
